import controller from './rules.controller';

const template = require('./rules.html');

export default {
    selector: 'configureRules',
    options: {
        controller,
        template
    }
};
